import React, { useRef, useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media, BREAK_POINT } from '@Utils/MediaQuery';
import useContextMenu from '@Hooks/useContextMenu';

import { useProcessIdsByItemName } from '@Services/Editor';
import ItemCell from './ItemCell';
import ItemContextMenu from './ItemContextMenu';

const DEFAULT_SELECTED_ITEM_NAME = '';

const StoreItem = ({
  itemElements,
  // scrollToTargetProcess,
  searchPidFunc,
}) => {
  const itemRef = useRef(null);
  const itemSellRefs = useRef([]);
  const [selectedItemName, setSelectedItemName] = useState(DEFAULT_SELECTED_ITEM_NAME);
  const [offsetSize, setOffsetSize] = useState({
    top: 0,
    left: 0,
  });

  const processIds = useSelector(useProcessIdsByItemName, shallowEqual);
  const { isContextMenuVisible, handleShowContextMenuClick, handleCloseContextMenuClick } = useContextMenu(false);

  const addToItemSellRefs = element => {
    if (element && !itemSellRefs.current.includes(element)) {
      itemSellRefs.current.push(element);
    }
  };

  const setOffsetSizeById = itemName => {
    const targetElement = itemSellRefs.current.find(({ id }) => id === itemName);
    const { offsetTop, offsetLeft } = targetElement;

    setOffsetSize({
      top: offsetTop,
      left: offsetLeft,
    });
  };

  const handleCloseContextMenu = () => {
    setSelectedItemName(DEFAULT_SELECTED_ITEM_NAME);
    handleCloseContextMenuClick();
  };

  const handleItemCellClick = (event, itemName) => {
    setSelectedItemName(itemName);
    setOffsetSizeById(itemName);
    handleShowContextMenuClick(event);
  };

  const handleContextMenuItemClick = async targetProcessId => {
    // await searchPidFunc(targetProcessId === 0 ? 1 : targetProcessId);
    await searchPidFunc(targetProcessId === 0 ? 0 : targetProcessId);

    handleCloseContextMenu();
  };

  const handleOutsideClick = event => {
    const { target } = event;

    if (itemRef === null || itemRef.current === null) {
      return;
    }

    if (!itemRef.current.contains(target)) {
      handleCloseContextMenu();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const targetProcessIdsByItemName = processIds[selectedItemName];

  return (
    <ItemContainer ref={itemRef}>
      {itemElements.map(name => (
        <ItemCell
          key={name}
          name={name}
          selectedItemName={selectedItemName}
          addToItemSellRefs={addToItemSellRefs}
          handleItemCellClick={handleItemCellClick}
        />
      ))}

      {isContextMenuVisible && (
        <ItemContextMenu
          offsetSize={offsetSize}
          processIds={targetProcessIdsByItemName}
          handleContextMenuItemClick={handleContextMenuItemClick}
        />
      )}
    </ItemContainer>
  );
};

StoreItem.propTypes = {
  itemElements: PropTypes.arrayOf(PropTypes.string).isRequired,
  // scrollToTargetProcess: PropTypes.func.isRequired,
};

const ItemContainer = styled.div`
  width: 100%;
  max-height: calc(100vh - 301px);

  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 6px;
  row-gap: 10px;

  overflow-y: scroll;

  ${media.lessThan(BREAK_POINT.XS)`
    max-height: 351px;
  `}
`;

export default StoreItem;
